/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Collaborateur d'une plateforme portant la brique Valideur, candidat valideur d'un tunnel.
 * @export
 * @interface ValideurDisponibleDto
 */
export interface ValideurDisponibleDto {
    /**
     * 
     * @type {string}
     * @memberof ValideurDisponibleDto
     */
    abpUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ValideurDisponibleDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideurDisponibleDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideurDisponibleDto
     */
    cabinet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideurDisponibleDto
     */
    plateformeId: string;
    /**
     * true quand le collaborateur est déjà valideur du tunnel.
     * @type {boolean}
     * @memberof ValideurDisponibleDto
     */
    dejaValideur: boolean;
}

/**
 * Check if a given object implements the ValideurDisponibleDto interface.
 */
export function instanceOfValideurDisponibleDto(value: object): value is ValideurDisponibleDto {
    if (!('abpUserId' in value) || value['abpUserId'] === undefined) return false;
    if (!('plateformeId' in value) || value['plateformeId'] === undefined) return false;
    if (!('dejaValideur' in value) || value['dejaValideur'] === undefined) return false;
    return true;
}

export function ValideurDisponibleDtoFromJSON(json: any): ValideurDisponibleDto {
    return ValideurDisponibleDtoFromJSONTyped(json, false);
}

export function ValideurDisponibleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValideurDisponibleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'abpUserId': json['abpUserId'],
        'nom': json['nom'] == null ? undefined : json['nom'],
        'email': json['email'] == null ? undefined : json['email'],
        'cabinet': json['cabinet'] == null ? undefined : json['cabinet'],
        'plateformeId': json['plateformeId'],
        'dejaValideur': json['dejaValideur'],
    };
}

export function ValideurDisponibleDtoToJSON(json: any): ValideurDisponibleDto {
    return ValideurDisponibleDtoToJSONTyped(json, false);
}

export function ValideurDisponibleDtoToJSONTyped(value?: ValideurDisponibleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'abpUserId': value['abpUserId'],
        'nom': value['nom'],
        'email': value['email'],
        'cabinet': value['cabinet'],
        'plateformeId': value['plateformeId'],
        'dejaValideur': value['dejaValideur'],
    };
}

